import {
    spotservellienceConstants
  } from '../_constants';
  import _ from 'lodash';
  export function spotservellience(state = {
    spotservellienceList: []
  }, action) {
    switch (action.type) {
      case spotservellienceConstants.GET_SPOTTYPE_REQUEST:
        return {
          ...state,
          loading: true
        };
      case spotservellienceConstants.GET_SPOTTYPE_SUCCESS:
        return {
          ...state,
          loading: false,
          getSpottype: action.getSpottype
        };
      case spotservellienceConstants.GET_SPOTTYPE_FAILURE:
        return {
          ...state,
          error: action.error
        };
  
   /** save SAVE_LICENSE_REQUEST state */
  
      case spotservellienceConstants.SAVE_QRINFO_REQUEST:
        return {
          ...state,
          loading: true
        };
      case spotservellienceConstants.SAVE_QRINFO_SUCCESS:
        return {
          ...state,
          loading: false,
          spotservellience: action.spotservellience
        };
      case spotservellienceConstants.SAVE_QRINFO_FAILURE:
        return {
          ...state,
          error: action.error
        };

        case spotservellienceConstants.GET_QRINFO_REQUEST:
        return {
          ...state,
          loading: true
        };
      case spotservellienceConstants.GET_QRINFO_SUCCESS:
        return {
          ...state,
          loading: false,
          spotservellience: action.qrInfo
        };
      case spotservellienceConstants.GET_QRINFO_FAILURE:
        return {
          ...state,
          error: action.error
        };

        case spotservellienceConstants.GET_PATROLLING_REQUEST:
        return {
          ...state,
          loading: true
        };
      case spotservellienceConstants.GET_PATROLLING_SUCCESS:
        return {
          ...state,
          loading: false,
          patrollingPerson: action.getPatrollingPerson
        };
      case spotservellienceConstants.GET_PATROLLING_FAILURE:
        return {
          ...state,
          error: action.error
        };


      default:
        return state
    }
  }